import React, { useEffect, useState } from 'react'
import { ResultsCount } from '../common/TopResultsSectionHeader'
import SortToggleFlexBox from '../common/SortToggleFlexBox'
import SearchSorting from 'components_v2/common/MenuDialog'
import { Flex } from 'ui/acro'
import GridIcon from 'components_v2/Icons/GridIcon'
import { HamburgerMenuIcon } from 'components_v2/Icons'
import { ToggleContainer, GridToggleBox } from '../common/GridToggleStyles'
import InfiniteScroll from 'react-infinite-scroll-component'
import axios from 'axios'
import AloMovesAnimation from '../common/AloMovesAnimation'
import { ClassCard } from 'components_v1/SchemaSectionRenderer/common/components'
import { useUserContext } from 'context'
import { useWindowResize } from 'hooks'

const ClassResultsPage = ({ query }) => {
  const batchSize = 18
  const [sorting, setSorting] = useState('')
  const [data, setData] = useState([])
  const [hitCount, setHitCount] = useState(0)
  const [offset, setOffset] = useState(0)
  const [hasMore, setHasMore] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const [toggleViewMode, setToggleViewMode] = useState(false)
  const { user } = useUserContext() || {}
  const { width } = useWindowResize()
  const isMobile = width < 640

  const sort = (value) => {
    setSorting(value)
    setOffset(0)
    setData([])
    setRefresh(refresh + 1)
  }

  const fetchData = async () => {
    try {
      const params = { q: query, from: offset, sort: sorting, size: batchSize }
      const res = await axios.get(`api/v2/search/classes`, { params })
      if (res && res.data && res.data.top) {
        setHitCount(res.data.result_count)
        setData((prevData) => [...prevData, ...res.data.top])

        if (res.data.top.length >= batchSize) {
          setHasMore(true)
          setOffset(res.data.top.length + offset)
        } else {
          setHasMore(false)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    fetchData()
  }, [refresh])

  const showSorting = hitCount > 3

  if (data && hitCount > 0) {
    return (
      <ToggleContainer>
        <SortToggleFlexBox
          flexDirection={['column', showSorting ? 'row-reverse' : 'row']} // accommodates different order whether sort is showing or not
        >
          {showSorting && (
            <SearchSorting applied={sort} location='search_classes' />
          )}
          <Flex justifyContent='space-between' alignItems='center' width='100%'>
            <ResultsCount>
              {hitCount} {hitCount !== 1 ? `classes` : `class`}
            </ResultsCount>
            {/* code below used for grid/list toggle */}
            <GridToggleBox onClick={() => setToggleViewMode(!toggleViewMode)}>
              <GridIcon color={toggleViewMode ? '#A3A3A3' : 'black'} />
              <HamburgerMenuIcon color={toggleViewMode ? 'black' : '#A3A3A3'} />
            </GridToggleBox>
          </Flex>
        </SortToggleFlexBox>
        <InfiniteScroll
          className={toggleViewMode ? 'list-view gap' : 'grid-view gap'}
          dataLength={data.length}
          next={() => {
            fetchData()
          }}
          hasMore={hasMore}
          loader={<AloMovesAnimation />}
        >
          {data.map((item, idx) => {
            const transformedData = {
              id: item.id,
              title: item.title,
              humanDuration: item.human_duration,
              videoThumbnail: item.thumbnail_image,
              plan: {
                title: item.series,
                difficultyLevel: item.difficulty_level,
                primaryCategory: {
                  title: item.category
                },
                subcategory: {
                  title: item.subcategory
                },
                coaches: item.coaches?.reduce((acc, coach) => {
                  return [
                    ...acc,
                    {
                      firstName: coach,
                      lastName: ''
                    }
                  ]
                }, [])
              },
              planEntryUrl: item.url,
              availabilityGating: item?.availability_gating
            }
            return (
              <ClassCard
                key={idx}
                isFevIcon={false}
                {...transformedData}
                isGridView={isMobile && !toggleViewMode}
                membershipTier={user?.membershipTier}
              />
            )
          })}
        </InfiniteScroll>
      </ToggleContainer>
    )
  } else return <></>
}

export default ClassResultsPage
